import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/store'

export interface IStorageDaysState {
  storageDays: string; // 文件列表记录存储天数
}
@Module({ dynamic: true, store, name: 'storage-days' })
class StorageDays extends VuexModule implements IStorageDaysState{
  public storageDays = '';

  @Mutation
  private SET_STORAGE_DAYS(storageDays: string) {
    this.storageDays = storageDays
  }

  @Action
  public SetStorageDays(storageDays: string) {
    this.SET_STORAGE_DAYS(storageDays)
  }
}

export const StorageDaysModule = getModule(StorageDays)

